import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '@websky/core/src/Link';
export var renderExchangeLinksLabel = function (companyInfo) {
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        t('Exchange:I agree with the'),
        "\u00A0",
        React.createElement(Link, { action: function () { } },
            React.createElement("span", { "data-type": "termsOfTariff" }, t('Exchange:terms of tariff'))),
        (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.exarePrivacyPolicyURL) && (React.createElement(React.Fragment, null,
            "\u00A0",
            t('Exchange:And'),
            "\u00A0",
            React.createElement(Link, { target: '_blank', action: companyInfo.exarePrivacyPolicyURL }, t('Exchange:Privacy Policy'))))));
};
export var renderRefundLinksLabel = function (companyInfo) {
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        t('Refund:I agree with the'),
        "\u00A0",
        React.createElement(Link, { action: function () { } },
            React.createElement("span", { "data-type": "termsOfTariff" }, t('Refund:terms of tariff'))),
        (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.exarePrivacyPolicyURL) && (React.createElement(React.Fragment, null,
            "\u00A0",
            t('Refund:And'),
            "\u00A0",
            React.createElement(Link, { target: '_blank', action: companyInfo.exarePrivacyPolicyURL }, t('Refund:Privacy Policy'))))));
};
